import { createContext, useContext, useState } from 'react';

import { ExitConfirmationModal } from '@/app/components/exit-confirmation-modal';

import type { Dispatch, SetStateAction } from 'react';

type ExitConfirmationModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  url: string;
  setUrl: Dispatch<SetStateAction<string>>;
};

const ExitConfirmationModalContext =
  createContext<ExitConfirmationModalProps | null>(null);

const ExitConfirmationModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  const value = { isModalOpen, setIsModalOpen, url, setUrl };

  return (
    <ExitConfirmationModalContext.Provider value={value}>
      <ExitConfirmationModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        url={url}
      />
      {children}
    </ExitConfirmationModalContext.Provider>
  );
};

const useExitConfirmationModalContext = () => {
  const context = useContext(ExitConfirmationModalContext);
  if (!context) {
    throw new Error(
      'useExitConfirmationModalContext must be used under <ExitConfirmationModalProvider/>'
    );
  }
  return context;
};

export { ExitConfirmationModalProvider, useExitConfirmationModalContext };
